import type { FilterValue, IdType, Row } from 'react-table'
import { type AttributionDateChannelAggregatedResponseV2 } from 'shared/api/analytics'
import type { ChartDataRowSort } from 'shared/components/ChartCard/types'
import { type AttributionDataKey, type ConfigWithStatus } from './types'

export const getPlatformNames = (attribution: ConfigWithStatus): string[] => {
  const platformNames: string[] = attribution.adAccounts.map((account) => account.platform)
  if (attribution.analyticsAccount != null) platformNames.push(attribution.analyticsAccount?.platform)
  return platformNames
}

export const getPlatformFilterOptions = (integratedAttributions: ConfigWithStatus[]): string[] => {
  if (integratedAttributions == null) return []
  const allPlatforms = new Set<string>()
  integratedAttributions.forEach((attribution) => {
    getPlatformNames(attribution).forEach((account) => allPlatforms.add(account))
  })
  return Array.from(allPlatforms)
}

export const platformFilterFn = (
  rows: Array<Row<ConfigWithStatus>>,
  columnIds: string[],
  filterValue: string | string[] | null | undefined
): Array<Row<ConfigWithStatus>> => {
  if (filterValue == null || (Array.isArray(filterValue) && filterValue.length === 0)) return rows
  return rows.filter((row) => {
    const platformNames = getPlatformNames(row.original)
    return platformNames.some((platform) =>
      Array.isArray(filterValue) ? filterValue.includes(platform) : filterValue === platform
    )
  })
}

export const platformRowMatchFilterFn = <T>(
  row: T,
  dependentAccessor: IdType<T>,
  filterValue: FilterValue
): boolean => {
  const platformNames = getPlatformNames(row as ConfigWithStatus)
  return platformNames.some((platform) =>
    Array.isArray(filterValue) ? filterValue.includes(platform) : filterValue === platform
  )
}

export const chartDataRowSort: ChartDataRowSort<AttributionDataKey, AttributionDateChannelAggregatedResponseV2> = (
  axisId,
  choiceId,
  dimension,
  metrics,
  data
) => {
  const sortedData = [...data]

  if (axisId === 'channelComparison' && choiceId === 'channel' && dimension === 'channelId') {
    sortedData.sort(
      (a, b) =>
        ((b[metrics[0] as keyof AttributionDateChannelAggregatedResponseV2] ?? 0) as number) -
        ((a[metrics[0] as keyof AttributionDateChannelAggregatedResponseV2] ?? 0) as number)
    )
  }

  return sortedData
}
